import React, { useContext, useEffect, useState } from 'react'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { CalendarPageContainer } from './MentorCalendarPageStyles'
import MentorHeader from '../MentorHeader'
import { Suspense } from 'react'
import { secondaryRoutes } from 'src/mentor/routes'
import { Route, Routes } from 'react-router-dom'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { CalendarOnboardingIntroductionComponent } from './MentorCalendarComponents'

const links = [
  { link: '', displayName: 'Your Events' },
  { link: 'availability', displayName: 'Availability' },
  { link: 'integrations', displayName: 'Integrations' },
]

export default function MentorCalendarPage() {
  const { mentorProfileData } = useContext(MentorProfileContext)
  const offersLive = mentorProfileData?.services?.live

  return (
    <>
      {mentorProfileData?.schedules && mentorProfileData?.schedules?.length > 0 ? (
        <>
          <MentorHeader
            greetingsEnabled={true}
            headerLinks={offersLive ? links : []}
            liveChecklist={true}
          />

          <CalendarPageContainer>
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                {secondaryRoutes?.map(({ path, name, Element, exact, ...props }, idx) => {
                  return (
                    Element && (
                      <Route
                        key={idx}
                        path={path}
                        exact={exact}
                        name={name}
                        element={<Element {...props} />}
                      />
                    )
                  )
                })}
              </Routes>
            </Suspense>
          </CalendarPageContainer>
        </>
      ) : (
        <>
          <MentorHeader greetingsEnabled={true} headerLinks={[]} />

          <CalendarOnboardingIntroductionComponent />
        </>
      )}
    </>
  )
}
